import DeleteExecutor from '@shared/execution/executors/delete-executor';
import InsertExecutor from '@shared/execution/executors/insert-executor';
import PullExecutor from '@shared/execution/executors/pull-executor';
import UpdateExecutor from '@shared/execution/executors/update-executor';
import { diContainer } from '@shared/infrastructure/di-container';
import { Flowstep, Operation } from '@shared/types/flowstep';
import { AwilixContainer } from 'awilix';
import Executor from './executors';

interface Factory {
  getExecutor(flowstep: Flowstep, context: any, scope?: AwilixContainer): Executor;
}

class ExecutorFactory implements Factory {
  constructor() {}

  private operationsExecutors: { [key in Operation]: new (...args: any[]) => Executor<any> } = {
    [Operation.PULL]: PullExecutor,
    [Operation.UPDATE]: UpdateExecutor,
    [Operation.INSERT]: InsertExecutor,
    [Operation.DELETE]: DeleteExecutor,
  };

  getExecutor(
    flowstep: Flowstep,
    context: Record<string, any>,
    scope: AwilixContainer = diContainer.createScope(),
  ): Executor<any> {
    const ExecutorClass = this.operationsExecutors[flowstep.operation];

    if (!ExecutorClass) {
      throw new Error(`No executor found for flowstep operation: ${flowstep.operation}`);
    }

    return scope.build((crud) => {
      const ex = new ExecutorClass(crud);
      ex.init(flowstep, context);
      return ex;
    });
  }
}

export default ExecutorFactory;
